/**
 * The demo tour's id in the guided-tour engine.
 *
 * Its own module so the demo-only chunk, the loader that lazily imports that
 * chunk, and the entry-point components can all name the same tour without any
 * of them importing each other — in particular without the chunk importing the
 * loader, which would make the same module both statically and lazily imported
 * (a Rollup TDZ crash; see `knowledge/GOTCHAS.md`).
 */
export const DEMO_TOUR_ID = 'demo-walkthrough'
